import { render, staticRenderFns } from "./NoteToCoach.vue?vue&type=template&id=36aae1db&scoped=true&"
import script from "./NoteToCoach.vue?vue&type=script&lang=js&"
export * from "./NoteToCoach.vue?vue&type=script&lang=js&"
import style0 from "./NoteToCoach.vue?vue&type=style&index=0&id=36aae1db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aae1db",
  null
  
)

export default component.exports